module.exports = __webpack_public_path__ + "img/profile_pic_male.03290bcd.svg";